import { createFileRoute } from "@tanstack/react-router";
import { apiQuery, useApiSuspenseQuery } from "@/client/lib/api";
import { ensurePage, pageHead } from "@/client/lib/page";
import { AtendimentoClient } from "@/client/modules/atendimento/paciente/atendimento-client";
import Loading from "@/client/modules/atendimento/paciente/loading";

type Search = {
  /** Liga o atendimento a um agendamento (vem da agenda). */
  appointmentId?: string;
  /** Editar uma consulta existente em vez de criar nova. */
  consultationId?: string;
};

export const Route = createFileRoute("/app/atendimento/$pacienteId")({
  validateSearch: (s: Record<string, unknown>): Search => ({
    appointmentId: s.appointmentId as string | undefined,
    consultationId: s.consultationId as string | undefined,
  }),
  loaderDeps: ({ search }) => search,
  loader: ({ context, params, deps }) =>
    ensurePage(
      context.queryClient,
      apiQuery("atendimento", "consultaPage", { pacienteId: params.pacienteId, ...deps }),
    ),
  head: () => pageHead("Atendimento"),
  pendingComponent: Loading,
  component: AtendimentoPage,
});

function AtendimentoPage() {
  const { pacienteId } = Route.useParams();
  const search = Route.useSearch();
  const { data } = useApiSuspenseQuery("atendimento", "consultaPage", { pacienteId, ...search });
  return <AtendimentoClient key={`${pacienteId}-${search.consultationId ?? ""}`} {...data} />;
}
